<script>
  import { onMount, onDestroy } from "svelte";
  let el;
  let portalTarget;
  const { onsuccess, children } = $props();

  onMount(() => {
    portalTarget = document.createElement("div");
    document.body.appendChild(portalTarget);
    portalTarget.appendChild(el);
    onsuccess?.();
  });

  onDestroy(() => {
    if (portalTarget) portalTarget.remove();
  });
</script>

<!-- 这里的 el 会被移动到 body 下的 portalTarget -->
<div bind:this={el}>
  {@render children?.()}
</div>
